import { useEffect, useState, useContext, useRef } from "react";
import { baseUrl } from "../../connections";
import { UserContext } from "../../context/UserContext";
import {
  getStoredAuthToken,
  persistUserSession,
} from "../../utils/authSession";

export const useProfile = () => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [payload, Setprofile] = useState(null);
  const lastFetchedProfileRef = useRef("");

  useEffect(() => {
    if (!payload) {
      return;
    }

    const authToken = userDetails?.token || getStoredAuthToken();
    const requestKey = `${payload}:${authToken || ""}`;

    if (!authToken || lastFetchedProfileRef.current === requestKey) {
      return;
    }

    lastFetchedProfileRef.current = requestKey;
    setIsLoading(true);

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("x-auth-token", authToken);

    const requestOptions = {
      method: "GET",
      headers,
      redirect: "follow",
    };

    fetch(`${baseUrl}/user/consumer/get/profile/${payload}`, requestOptions)
      .then(async (response) => {
        const res = await response.text();
        if (response.status !== 200) {
          throw res;
        }
        return JSON.parse(res);
      })
      .then((result) => {
        const sessionPayload = {
          ...userDetails,
          ...(result?.data || {}),
          token: result?.token || authToken,
        };

        persistUserSession({
          data: sessionPayload,
          setUserDetails,
        });
        setData(result);
        setError(false);
        setIsLoading(false);
      })
      .catch((err) => {
        lastFetchedProfileRef.current = "";
        setError(err);
        setIsLoading(false);
      });
  }, [payload, setUserDetails, userDetails]);

  return {
    Profilelist: data,
    isLoading,
    error,
    Setprofile,
  };
};
